import { render } from "./FileIcon.vue?vue&type=template&id=03c9c67d&scoped=true"
import script from "./FileIcon.vue?vue&type=script&lang=js"
export * from "./FileIcon.vue?vue&type=script&lang=js"

import "./FileIcon.vue?vue&type=style&index=0&id=03c9c67d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c9c67d"]])

export default __exports__